import { useQuery } from 'react-query';
import { groupResponse } from 'src/models/CRM';
import { fetchGroup } from 'src/services/CRM/groups';

export default function useGroup(id) {
  return useQuery<groupResponse>('group', () => fetchGroup(id), {
    enabled: id !== undefined && id !== 0
  });
}
